/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_timer_stopwatch_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`It measures to a hundredth of a second and is driven by the device clock, so pausing and resuming stays accurate.`)
};

const es_timer_stopwatch_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mide hasta la centésima de segundo y funciona con el reloj del dispositivo, así que pausar y reanudar se mantiene preciso.`)
};

const de_timer_stopwatch_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sie misst auf die Hundertstelsekunde genau und wird von der Geräteuhr angetrieben, sodass Pausieren und Fortsetzen genau bleibt.`)
};

const nl_timer_stopwatch_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hij meet tot op een honderdste seconde en wordt aangestuurd door de klok van je apparaat, waardoor pauzeren en hervatten nauwkeurig blijft.`)
};

const fr_timer_stopwatch_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il mesure au centième de seconde et se base sur l’horloge de l’appareil, donc les pauses et reprises restent précises.`)
};

const it_timer_stopwatch_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Misura al centesimo di secondo ed è guidato dall'orologio del dispositivo, quindi mettere in pausa e riprendere resta preciso.`)
};

const pt_br2_timer_stopwatch_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ele mede com precisão de centésimos de segundo e é controlado pelo relógio do dispositivo, então pausar e retomar mantém a precisão.`)
};

const pt_timer_stopwatch_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mede com precisão de um centésimo de segundo e é regido pelo relógio do dispositivo, pelo que pausar e retomar se mantém exato.`)
};

const ja_timer_stopwatch_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1/100秒単位で計測し、デバイスの時計を基準に動作するため、一時停止と再開を繰り返しても正確さが保たれます。`)
};

const zh_timer_stopwatch_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`秒表精确到百分之一秒，由设备时钟驱动，因此暂停和恢复都能保持准确。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const timer_stopwatch_faq2_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.timer_stopwatch_faq2_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("timer_stopwatch_faq2_a", locale)
	if (locale === "en") return en_timer_stopwatch_faq2_a(inputs)
	if (locale === "es") return es_timer_stopwatch_faq2_a(inputs)
	if (locale === "de") return de_timer_stopwatch_faq2_a(inputs)
	if (locale === "nl") return nl_timer_stopwatch_faq2_a(inputs)
	if (locale === "fr") return fr_timer_stopwatch_faq2_a(inputs)
	if (locale === "it") return it_timer_stopwatch_faq2_a(inputs)
	if (locale === "pt-BR") return pt_br2_timer_stopwatch_faq2_a(inputs)
	if (locale === "pt") return pt_timer_stopwatch_faq2_a(inputs)
	if (locale === "ja") return ja_timer_stopwatch_faq2_a(inputs)
	return zh_timer_stopwatch_faq2_a(inputs)
};